import { Component, OnInit, Input } from '@angular/core';
import { ContactMessage } from 'src/app/contact/contact-message.model';
import { UserService } from 'src/app/user/user.service';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-contact-conversation-message',
  templateUrl: './contact-conversation-message.component.html',
  styleUrls: ['./contact-conversation-message.component.scss']
})
export class ContactConversationMessageComponent implements OnInit {
  @Input() conversationMessage: ContactMessage;
  @Input() isCurrentViewer: boolean;
  senderName$: Observable<string>;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.senderName$ = this.userService
      .getUserDetailsByKey(this.conversationMessage.senderKey)
      .pipe(
        filter(sender => !!sender),
        map(sender => `${sender?.firstName} ${sender?.lastName}`)
      );
  }

  get dateDisplay(): string {
    return moment(this.conversationMessage.timeStamp.toDate()).format(
      'HH:mm do MMMM YYYY'
    );
  }
}
